export const cdn = '/assets/vt-aplusmath/images';
export const geoTiles = [
  'acute angle',
  'chord',
  'circle',
  'closed curve',
  'diameter',
  'equilateral triangle',
  'hexagon',
  'intersecting line segments',
  'isosceles triangle',
  'line segment',
  'line',
  'obtuse angle',
  'obtuse triangle',
  'octagon',
  'parallel line segments',
  'pentagon',
  'point',
  'radius',
  'ray',
  'rhombus',
  'right angle',
  'right triangle',
  'trapezoid',
  'vertex'
];

export const bgImages = [
  'anim0007',
  'anim0008',
  'anim0012',
  'anim0021',
  'anim0045',
  'anim0215',
  'anim0261',
  'anim0273',
  'anim0406',
  'anim0408',
  'anim0410',
  'anim0419',
  'anim0491',
  'anim0610',
  'anim0611',
  'anim0614',
  'anim0618',
  'anim0801',
  'anim0802',
  'anim0840',
  'corp1516',
  'corp1531',
  'corp2404',
  'corp2417',
  'corp2442',
  'fish0377',
  'fish0458',
  'fish0481',
  'fish2001',
  'fly00001',
  'fly00006',
  'fly00065',
  'fly00519',
  'mvey0006',
  'nerr0004',
  'nerr0086',
  'nssl0010',
  'nssl0131',
  'nur00001',
  'nur00502',
  'nur00511',
  'nur00515',
  'nur00523',
  'nur01015',
  'nur01519',
  'nur02004',
  'nur03002',
  'reef0121',
  'reef0196',
  'reef1508',
  'reef1515',
  'reef2565',
  'reef2575',
  'reef2576',
  'reef2581',
  'reef2591',
  'sanc0101',
  'sanc0114',
  'sanc0119',
  'sanc0124',
  'sanc0404',
  'sanc0406',
  'sanc0501',
  'sanc0504',
  'sanc0515',
  'sanc0601',
  'sanc0806',
  'sanc0807',
  'sanc0809',
  'sanc0810',
  'sanc1006',
  'ship0171',
  'ship0209',
  'spac0249',
  'spac0259',
  'spac0264',
  'theb1450',
  'theb3677'
];

export function mathTiles(mathType) {
  let tiles = [];
  for (var i = 0; i < 10000; i++) {
    let newTile = MathPuzzle[mathType]();
    if (!found(newTile, tiles)) {
      tiles.push(newTile);
    }
    if (tiles.length >= 16) {
      return tiles;
    }
  }
}

function found(needle, haystack) {
  return (haystack.filter((straw) => {
    if (typeof straw == 'undefined') return false;
    return needle[0] === straw[0];  // answers are on 0;
  }).length > 0);
}

export const displayKey = {
  'problem': 0,
  'answer': 1
};

const limit = 16;

const MathPuzzle = {
  addition: function() {
    const a = rollDice(limit)+1;
    const b = rollDice(limit)+1;
    return [
      a + b,            // Answer [0]
      `${a} + ${b}`     // Problem [1]
    ];
  },

  subtraction: function() {
    const b = rollDice(limit)+1;
    const c = rollDice(limit)+1;
    const a = b + c;
    return [
      c,
      `${a} - ${b}`
    ];
  },

  multiplication: function() {
    const a = rollDice(limit)+1;
    const b = rollDice(limit)+1;
    return [
      a * b,
      `${a} × ${b}`
    ];
  },

  division: function() {
    const b = rollDice(limit)+1;
    const c = rollDice(limit)+1;
    const a = c * b;
    return [
      c,
      `${a} ÷ ${b}`
    ];
  }
};

export function shuffle(array) {
  var currentIndex = array.length, temporaryValue, randomIndex ;

  // While there remain elements to shuffle...
  while (0 !== currentIndex) {

    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;

    // And swap it with the current element.
    temporaryValue = array[currentIndex];
    array[currentIndex] = array[randomIndex];
    array[randomIndex] = temporaryValue;
  }

  return array;
}

export function rollDice(sides) {
  return Math.floor(Math.random() * sides);
}

export function tilesByGameType(type) {
  switch(type) {
    case 'geometry':
      return geoTiles;
    default:
      return mathTiles(type);
  }
}


export function typeFromURL() {
  switch (location.pathname) {
    case '/aplusmath/hidden-picture/division':
      return 'division';
    case '/aplusmath/hidden-picture/addition':
      return 'addition';
    case '/aplusmath/hidden-picture/subtraction':
      return 'subtraction';
    case '/aplusmath/hidden-picture/multiplication':
      return 'multiplication';
    case '/aplusmath/hidden-picture/geometry':
      return 'geometry';
  }
}



/** WEBPACK FOOTER **
 ** ./client/app/scripts/components/hidden-picture/lib/tiles.js
 **/